<template>
  <AppDialog
    :open="visible"
    :closable="closable"
    @close="close"
    classes="login-dialog"
    :from="from"
  >
    <div class="columns">
      <div>
        <Headline :size="1">Jetzt einloggen</Headline>
        <LoginForm :from="from" />
        <div class="footer">
          <span></span>
          <t-button
            type="link"
            classes="inline-button accent"
            :action="handleForgotPassword"
            >Passwort vergessen ?</t-button
          >
          <span>Noch keinen Account?</span>
          <t-button
            classes="outline"
            label="Registrieren"
            :action="handleRegister"
            >Registrieren</t-button
          >
        </div>
      </div>
      <div>
        <img :src="assetDomain + 'assets/factfield.png'" />
        <Headline :size="4">Hinweis</Headline>
        <p>
          Aktuell steht der Login-Bereich ausschließlich Ärzten zur Verfügung,
          welche von FactField im Rahmen der Befragung für die FOCUS-Ärzteliste
          2021 kontaktiert wurden.
        </p>
      </div>
    </div>
    <ForgotPasswordDialog
      :from="from"
      v-if="forgotPwd"
      :visible="forgotPwd"
      @close="forgotPwd = false"
    />
  </AppDialog>
</template>

<script>
import AppDialog from "@/components/Dialog/AppDialog";
import Headline from "@/components/Layout/Headline";
import LoginForm from "@/components/Forms/LoginForm";
import TButton from "@/components/Layout/Button";
import ForgotPasswordDialog from "@/components/Dialog/ForgotPasswordDialog";
import { errorHandler } from "@/router/utils";
import { ASSET_DOMAIN } from "@/services";
export default {
  name: "LoginDialog",
  props: {
    from: {
      type: String,
      default: () => "main",
      required: false,
    },
    closable: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    ForgotPasswordDialog,
    TButton,
    LoginForm,
    Headline,
    AppDialog,
  },
  data() {
    return {
      assetDomain: ASSET_DOMAIN,
      visible: true,
      forgotPwd: false,
    };
  },
  methods: {
    close() {
      if (this.$listeners.close) {
        this.$listeners.close();
      } else {
        this.visible = false;
      }
    },
    handleForgotPassword() {
      this.forgotPwd = true;
    },
    handleRegister() {
      this.visible = false;

      if (this.$router) {
        this.$nextTick(() =>
          this.$router.push("/register").catch(errorHandler)
        );
      } else {
        // send navigation event to main app
        window.location.href = "/app/#/register";
      }
    },
  },
};
</script>

<style>
.login-dialog {
  @screen lg {
    max-width: 50% !important;
  }

  section {
    @apply p-0 !important;

    .columns {
      @apply grid grid-cols-1 gap-0;

      @screen lg {
        @apply grid grid-cols-2 gap-0;
        grid-template-columns: 60% 40%;
      }

      > div:first-of-type {
        @apply bg-white py-16 px-8 order-2 pt-0;

        @screen lg {
          @apply order-1 py-32;
        }
        .inline-button {
          @apply text-sm text-right mb-4 text-primary !important;
        }

        span {
          @apply text-primary pt-2;
        }

        .accent {
          @apply text-ff02 justify-self-end !important;
          width: fit-content;
        }

        h2 {
          @apply mb-0 text-center;

          @screen lg {
            @apply mb-8;
          }
        }

        .footer {
          @apply grid grid-cols-2 mt-8;
        }
      }

      > div:last-of-type {
        @apply bg-white px-8 py-8 pb-0 order-1;

        @screen lg {
          @apply order-2 bg-gray-light pb-16 pt-24;
        }

        p {
          @apply hidden;

          @screen lg {
            @apply block;
          }
        }

        img {
          @apply mt-16 mb-8;
        }

        h4 {
          @apply text-ff02 font-medium mt-8 hidden;
          @screen lg {
            @apply block;
          }
        }
      }
    }
  }
}
</style>
